import React from "react";
import { cn } from "utils/cn";
import { usePageContent } from "customProviders/LocationProvider";
import {
  CLOSE_HAMBURGER_MENU,
  OPEN_HAMBURGER_MENU
} from "resources/hamburger-nav.json";
import { motion } from "motion/react";

type HamburgerButtonProps = {
  isOpen: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const HamburgerButton = ({ isOpen, onClick }: HamburgerButtonProps) => {
  const { pageContent } = usePageContent();
  const CLOSE_HAMBURGER_LABEL =
    pageContent?.hamburgerNav?.CLOSE_HAMBURGER_MENU ?? CLOSE_HAMBURGER_MENU;
  const OPEN_HAMBURGER_LABEL =
    pageContent?.hamburgerNav?.OPEN_HAMBURGER_MENU ?? OPEN_HAMBURGER_MENU;

  return (
    <button
      id="animatedHamburgerContainer"
      onClick={e => {
        onClick(e);
      }}
      aria-haspopup="true"
      aria-expanded={isOpen}
      aria-label={isOpen ? CLOSE_HAMBURGER_LABEL : OPEN_HAMBURGER_LABEL}
      className={cn(
        "flex cursor-pointer flex-col items-center justify-center p-0 text-inherit",
        "h-[22px] w-[22px] sm:h-[26px] sm:w-[26px]"
      )}
    >
      <div className="flex h-4 w-[22px] flex-col items-center justify-between">
        {/* Top line */}
        <motion.div
          initial={false}
          animate={isOpen ? "open" : "closed"}
          variants={{
            open: { y: 7.5, rotate: 45 },
            closed: { y: 0, rotate: 0 }
          }}
          transition={{
            y: { duration: 0.3, delay: isOpen ? 0 : 0.3 },
            rotate: { duration: 0.3, delay: isOpen ? 0.3 : 0 }
          }}
          className="w-[22px] border-b-[0.75px] border-current bg-transparent"
        />

        {/* Middle line */}
        <motion.div
          initial={false}
          animate={isOpen ? "open" : "closed"}
          variants={{ open: { opacity: 0 }, closed: { opacity: 1 } }}
          transition={{ duration: 0.3, delay: isOpen ? 0 : 0.3 }}
          className="w-[22px] border-b-[0.75px] border-current bg-transparent"
        />

        {/* Bottom line */}
        <motion.div
          initial={false}
          animate={isOpen ? "open" : "closed"}
          variants={{
            open: { y: -7.5, rotate: -45 },
            closed: { y: 0, rotate: 0 }
          }}
          transition={{
            y: { duration: 0.3, delay: isOpen ? 0 : 0.3 },
            rotate: { duration: 0.3, delay: isOpen ? 0.3 : 0 }
          }}
          className="w-[22px] border-b-[0.75px] border-current bg-transparent"
        />
      </div>
    </button>
  );
};

export default HamburgerButton;
